/**
 * One-shot dayjs initialisation — extend with utc + timezone + the
 * relative-time plugin so {@code dayjs(value).tz(...)} and
 * {@code dayjs(value).fromNow()} work everywhere.
 *
 * Imported once from {@code src/index.js} so the plugins are in place
 * before any component first calls dayjs.
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);

export default dayjs;
